import {ChangeDetectorRef, Component, isDevMode, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {SearchService} from "@services/search.service";
import * as _ from "underscore";
import {maxDate, maxYear, minDate, minYear, populateYears, timer} from "@services/common";
import {environment} from "@env/environment";
import {OptionsService} from "@services/options-service.service";
import {ISearchObj} from "@models/search.interface";
import {Reports} from "@services/reports";
import {Accordion, TabView} from "primeng/primeng";
import {Table} from "primeng/table";
import {isNullOrUndefined} from "util";
import {HttpErrorResponse} from "@angular/common/http";
import {AssrNumber} from "@directives/assrNumbers/assrNumber";
import { EsriLoaderService } from '../../services/esri-loader.service';

declare let moment: any;

declare var jmespath: any;

@Component({
  selector:"app-main-search",
  templateUrl:"./main-search.component.html",
  styleUrls:["./main-search.component.scss"],
  encapsulation:ViewEncapsulation.None
})
export class MainSearchComponent implements OnInit, OnChanges {
  /*FLAGS*/
  _SIP = false;
  usingFile = false;
  status = "";
  tableRows: number = 10;
  exportDisabled = true;

  searchBool:boolean =  true;

  /*App Objects*/
  advSrchFormGrp: FormGroup;
  advFormBuilder: FormBuilder = new FormBuilder();
  environment = environment;

  /*Form Field Filter Containers*/
  filteredSubs: Array<any> = [];
  filteredDistricts: Array<any> = [];
  filteredAuthorities: Array<any> = [];
  filteredFilings: Array<any> = [];
  filteredStreets: Array<any> = [];
  filteredLandUses: Array<any> = [];
  filteredNeighborhoods: Array<any> = [];
  filteredNeighborhoodExtensions: Array<any> = [];
  reportModel = "PropertyOwnershipAndLocationReport";
  reportList: Array<any>;
  currentMapExtent;
  
  /*DATA
   and Route Resolver*/
  options = {
    account_types:[],
    building_styles:[],
    building_uses:[],
    cities:[],
    land_attributes:[],
    land_uses:[],
    quality:[],
    range:[],
    section:[],
    subdivisions:[],
    tax_authorities:[],
    tax_districts:[],
    township:[],
    zip_codes:[],
    yearBuilt:[],
    deed_types:[],
    vacant_improved:[],
    multi_parcel:[],
    qualified_sale:[],    
    neighborhoods:[],
    neighborhood_extensions:[],
    leas:[]
  };
  resultObject: ISearchObj;
  counter: number = 0;
  minSaleDate: Date;
  maxSaleDate: Date;
  minYear: number;
  maxYear: number;
  resultHide:boolean =true;
  reportLabel:string = "Map";

  selectedIndex: number = 0;
  @ViewChild(TabView) tabView: TabView;

  @ViewChild(Accordion) accordionWrapper: Accordion;
  columns: Array<any> = [];

  constructor(private route: ActivatedRoute, private searchSvc: SearchService,
              private esriLoaderService:EsriLoaderService,
              private _Reports: Reports, private optionSvc: OptionsService, private cdref:ChangeDetectorRef) {
    this.reportList = _Reports.selectionList;
    this.advSrchFormGrp = this.advFormBuilder.group({
      accountFile:new FormControl(null),
      accounts:new FormControl(null),
      accountType:new FormControl(null),
      acresMax:new FormControl(null),
      acresMin:new FormControl(null),
      appraisalType:new FormControl(null),
      basementFinish:new FormControl(null),
      basementSQFTMax:new FormControl(null),
      basementSQFTMin:new FormControl(null),
      basementWalkOut:new FormControl(null),
      block:new FormControl(null),
      builtAs:new FormControl(null),
      city:new FormControl(null),
      landAttribute:new FormControl(null),
      landUse:new FormControl(null),
      lot:new FormControl(null),
      occupancyCode:new FormControl(null),
      ownerName:new FormControl(null),
      propertyValueMax:new FormControl(null),
      propertyValueMin:new FormControl(null),
      quality:new FormControl(null),
      range:new FormControl(null),
      reportSelector:new FormControl(null),
      saleDateMax:new FormControl(null),
      saleDateMin:new FormControl(null),
      salePriceMax:new FormControl(null),
      salePriceMin:new FormControl(null),
      saleRecordingNumber:new FormControl(null),
      section:new FormControl(null),
      spnMax:new FormControl(null),
      spnMin:new FormControl(null),
      squareFootageMax:new FormControl(null),
      squareFootageMin:new FormControl(null),
      streetName:new FormControl(null),
      streetNumberMax:new FormControl(null),
      streetNumberMin:new FormControl(null),
      sub_filings:new FormControl(null),
      subDivision:new FormControl(null),
      taxAuthority:new FormControl(null),
      taxDistrict:new FormControl(null),
      township:new FormControl(null),
      tract:new FormControl(null),
      yearBuiltMax:new FormControl(null),
      yearBuiltMin:new FormControl(null),
      zipCode:new FormControl(null),
      grantor:new FormControl(null),
      grantee:new FormControl(null),
      deedType:new FormControl(null),
      vacant_improved:new FormControl(null),
      multi_parcel:new FormControl(null),
      qualified_sale:new FormControl(null),
      neighborhood:new FormControl(null),
      neighborhood_extension:new FormControl(null),
      lea:new FormControl(null),
      recording_number: new FormControl(null),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();

  }

  uniqueAccounts:any;

  uniqueAccEmitter(data) {

     this.uniqueAccounts = data;
  }

  ngOnInit(): void {
    this.minSaleDate = new Date(minDate);
    this.maxSaleDate = new Date(maxDate);
    this.minYear = minYear;
    this.maxYear = maxYear;

    this.searchSvc.searchResults.subscribe({
      next:(newVals: ISearchObj) => {
        this.resultObject = newVals;
      }
    });

    this.searchSvc.SearchInProgress.subscribe(
      (status: boolean) => {
        this._SIP = typeof status == "object" ? false : status;
      }
    );
    /*load the data from the route resolver*/
    if (this.route.snapshot.data["options"]) {
      this.options.account_types = this.objectify(this.route.snapshot.data["options"]._source.account_types);
      this.options.building_styles = this.route.snapshot.data["options"]._source.building_styles;
      this.options.building_uses = this.route.snapshot.data["options"]._source.building_uses;
      this.options.cities = this.route.snapshot.data["options"]._source.cities;
      this.options.land_attributes = this.route.snapshot.data["options"]._source.land_attributes;
      this.options.land_uses = this.route.snapshot.data["options"]._source.land_uses;
      this.options.quality = this.route.snapshot.data["options"]._source.quality;
      this.options.range = this.route.snapshot.data["options"]._source.range;
      this.options.section = this.route.snapshot.data["options"]._source.section;
      this.options.subdivisions = this.route.snapshot.data["options"]._source.subdivisions;
      this.options.tax_authorities = this.route.snapshot.data["options"]._source.tax_authorities;
      this.options.tax_districts = this.route.snapshot.data["options"]._source.tax_districts;
      this.options.zip_codes = this.objectify(this.route.snapshot.data["options"]._source.zip_codes);
      this.options.deed_types = this.objectify(this.route.snapshot.data["options"]._source.deed_types);      
      this.options.neighborhoods = this.route.snapshot.data["options"]._source.neighborhoods;
      this.options.leas = this.route.snapshot.data["options"]._source.leas;
      this.options.quality = [
        {label:"Excellent", value:"Excellent"}, {label:"Very Good", value:"Very Good"}, {
          label:"Good",
          value:"Good"
        },
        {label:"Average", value:"Average"}, {label:"Fair", value:"Fair"}, {label:"Low", value:"Low"}];
      this.options.cities = [
        {label:"AURORA", value:"AURORA"},
        {label:"CASTLE PINES", value:"CASTLE PINES"},
        {label:"CASTLE ROCK", value:"CASTLE ROCK"},
        {label:"ELBERT", value:"ELBERT"},
        {label:"ELIZABETH", value:"ELIZABETH"},
        {label:"ENGLEWOOD", value:"ENGLEWOOD"},
        {label:"FRANKTOWN", value:"FRANKTOWN"},
        {label:"HIGHLANDS RANCH", value:"HIGHLANDS RANCH"},
        {label:"LARKSPUR", value:"LARKSPUR"},
        {label:"LITTLETON", value:"LITTLETON"},
        {label:"LONE TREE", value:"LONE TREE"},
        {label:"LOUVIERS", value:"LOUVIERS"},
        {label:"PALMER LAKE", value:"PALMER LAKE"},
        {label:"PARKER", value:"PARKER"},
        {label:"SEDALIA", value:"SEDALIA"}
      ];
      this.options.township = [{label:6, value:6}, {label:7, value:7}, {label:8, value:8}, {label:9, value:9}, {
        label:10,
        value:10
      }];
      this.options.range = [
        {label:65, value:65},
        {label:66, value:66},
        {label:67, value:67},
        {label:68, value:68},
        {label:69, value:69}
      ];
      this.options.section = [
        {label:1, value:1},
        {label:2, value:2},
        {label:3, value:3},
        {label:4, value:4},
        {label:5, value:5},
        {label:6, value:6},
        {label:7, value:7},
        {label:8, value:8},
        {label:9, value:9},
        {label:10, value:10},
        {label:11, value:11},
        {label:12, value:12},
        {label:13, value:13},
        {label:14, value:14},
        {label:15, value:15},
        {label:16, value:16},
        {label:17, value:17},
        {label:18, value:18},
        {label:19, value:19},
        {label:20, value:20},
        {label:21, value:21},
        {label:22, value:22},
        {label:23, value:23},
        {label:24, value:24},
        {label:25, value:25},
        {label:26, value:26},
        {label:27, value:27},
        {label:28, value:28},
        {label:29, value:29},
        {label:30, value:30},
        {label:31, value:31},
        {label:32, value:32},
        {label:33, value:33},
        {label:34, value:33},
        {label:35, value:35},
        {label:36, value:36}
      ];
      this.options.yearBuilt = populateYears();

      this.options.vacant_improved = [
        {label:"Vacant And Improved", value:null}, 
        {label:"Improved Only", value:true}, 
        {label:"Vacant Only", value:false}
      ];
      this.options.multi_parcel = [
        {label:"Multiple And Single", value:null},     
        {label:"Multi-Parcel", value:true},
        {label:"Single-Parcel", value:false}
 
      ];
      this.options.qualified_sale = [
        {label: "Qualified And Disqualified", value:null},       
        {label: "Qualified Sales", value:true},
        {label: "Disqualified Sales", value:false}

      ]

      this.filterAuthorities();
      this.filterLandUses();
      this.filterSubdivision();
      this.filterNeighborhoods();

      /*These subscriptions are for child form field dependencies */
      this.advSrchFormGrp.get("taxDistrict").valueChanges.subscribe(val => {
        this.filterAuthorities(val);
      });
      this.advSrchFormGrp.get("subDivision").valueChanges.subscribe(val => {
        this.filterFilings(val);
      });
      this.advSrchFormGrp.get("neighborhood").valueChanges.subscribe(val => {
        this.filterNeighborhoodExtensions(val);
      });      
    } else {

    }
    this.cdref.detectChanges();
  }

  /* take a string array and builds a primeNG options object array */
  objectify(values: Array<string>): Array<any> {
    if (!values) {
      return;
    }
    let newVals: Array<{ label: string, value: string }> = [];
    values.forEach(val => {
      newVals.push({label:val, value:val});
    });
    return newVals;
  }

  /* for swapping the file input with the account field*/
  setFileFlag(e: any): void {
    e.preventDefault();
    this.usingFile = !this.usingFile;
  }

  /*Take a guess...*/
  resetForm(ctrl ?: FormControl): void {

    this.advSrchFormGrp.reset();
    this.searchSvc.resetResults();
    this.status = "";
    this.selectedIndex = 0;
    this.currentMapExtent = null;
    this.esriLoaderService.resetForm.next(true);
    toastr.info("Form Reset");
  }
 
  getCtrlVal(ctrls: string[]): Array<any> {
    let _values: Array<any> = [];

    ctrls.forEach((ctrl: string) => {
      let ctrlVal = this.advSrchFormGrp.getRawValue()[ctrl];
      if (isNullOrUndefined(ctrlVal)) {
        return null;
      } else {
        let key = new RegExp(/(label|description|name)/ig);
        let type = this.getCtrlValueType(ctrl);

        switch (type) {
          case "string":
            if (ctrlVal !== "") {
              _values.push(ctrlVal);
            }
            break;
          case "number":
            _values.push(ctrlVal);
            break;
          case "boolean":
            _values.push(ctrlVal === false ? "no" : "yes");
            break;
          case "date":
            ctrlVal = ctrlVal as Date;
            _values.push(ctrlVal.toDateString());
            break;
          case "object":
            _values.push(ctrlVal["label"] || ctrlVal["name"] || ctrlVal["description"]);
            break;
          case "array":
            ctrlVal.map((val: any) => {
              if (typeof val == "object") {
                _values.push(val["label"] || val["name"] || val["description"]);
              } else {
                _values.push(val);
              }
            });
            break;
        }
      }

    });
    return _values;

  }

  getCtrlValueType(ctrl: string): string {
    let _type: string = typeof(this.advSrchFormGrp.getRawValue()[ctrl]);
    if (_type === "object") {
      if (Array.isArray(this.advSrchFormGrp.getRawValue()[ctrl])) {
        _type = "array";
      }
    }
    return _type;
  }

  /* takes the file data and regex matches any account found in the document*/
  purifyImportedAccounts(fileInput: any): void {
    const _file: any = fileInput.files[0];
    if (_file.type !== "text/plain" && _file.type !== "application/vnd.ms-excel") {
      toastr.error("Please use plain text files (*.txt or *.csv) for import.");
      fileInput.value = "";
      return;
    }

    const _reader: FileReader = new FileReader();
    /*ES6 File reader*/
    const r: RegExp = new RegExp(/([RMCP][\d]{7})/m);
    const _goodAccounts: Array<string> = [];
    const _self: any = this;
    try {      /*set up the processing on end of load*/
      _reader.onloadend = function () {
        const lines: Array<string> = this.result.split("\n");
        lines.forEach((line: string) => {
          if (r.test(line)) {
            _goodAccounts.push(r.exec(line)[0]);
          }
        });
        _self.advSrchFormGrp.controls["accounts"].setValue(_goodAccounts.join(","));
        toastr.success("Parsed " + _goodAccounts.length + " accounts.");
        $("#accounts").focus();
      };
      /*set up the processing on error */
      _reader.onerror = (ex) => {
        _self.advSrchFormGrp.controls["accounts"].setValue("");
        toastr.error(ex.target.error.message);
      };
      /* Read file and do stuff */
      _reader.readAsText(_file);
    } catch (ex) {
      toastr.error(ex, "setFileFlag: " + _file.name);
    }
    this.usingFile = false;
  }

  /*mirrors the min spn to the max as you type*/
  setMaxSPN(event: any) {
    this.advSrchFormGrp.controls["spnMax"].setValue(event.currentTarget.children[0].value);
  }

  /*unused at the moment, but would clear the chips when a control was cleared*/
  chipClear(e, controls: Array<string>): void {
    controls.map((ctrl: string) => {
      this.advSrchFormGrp.controls[ctrl].reset(null, {emitEvent:true});
    });
    e.stopPropagation();
    e.preventDefault();

  }

  /* typeahead filtering*/
  filterSubdivision(subStub?: any): Array<any> {
    let self = this;
    this.filteredSubs = [];
    if (!subStub) {
      self.options["subdivisions"].forEach(obj => {
        // self.filteredSubs.push({name:obj.name, number:obj["number"]});
        self.filteredSubs.push({label:obj.name, value:obj["number"], sub_filings:obj.sub_filings});       
      });
    } else {
      self.options["subdivisions"].filter(obj => {
        if (obj.name.toLowerCase().indexOf(subStub.query.toLowerCase()) > -1) {
          self.filteredSubs.push({label:obj.name, value:obj["number"], sub_filings:obj.sub_filings});
        }
      });
    }
    return this.filteredSubs;
  }

  /* filters filings based on subdivision*/
  filterFilings(subDivisionVals: Array<any>): void {
    this.filteredFilings = [];

    // old version
    // if (subDivisionVals) {
    //   subDivisionVals.map((subDivision: any) => {
    //     subDivision.sub_filings.map((filing: any) => {
    //       this.filteredFilings.push(
    //         {
    //           value:filing.recording_number,
    //           description:filing.description,
    //           label:filing.description ? filing.filing_number + " - " + filing.description : filing.filing_number,
    //           filing_number:filing.filing_number,
    //           recording_number:filing.recording_number
    //         }
    //         );
    //       });
    //     });
    //     this.filteredFilings = _.uniq(this.filteredFilings, (item) => {
    //       return item;
    //     }).sort((a, b) => {
    //       return Number(a.description > b.description) - Number(a.description < b.description);
    //     });
    //     console.log(this.filteredFilings);
    //   }        

    if (subDivisionVals) {
      //************************************ */
      //Different way to do the same thing
      //************************************ */      
      // const filterSub = ((num:string) => {
      //   return this.options.subdivisions.filter(subdivision => subdivision.number === num);
      // });
  
      // let  t = subDivisionVals.map((val: any) => {
      //     return filterSub(val.number);
      //   });
  
      // flattening multidimensional arrays t from t[][] to t[] and assign to t1
      // let t1 = [].concat(...t);
  
      // t1.map((t2:any) => {
      //   let sub_filings = t2.sub_filings;
      //   sub_filings.map((sub_filing:any) => {
      //     this.filteredFilings.push({
      //       value:sub_filing.recording_number,
      //       description:sub_filing.description,
      //       label:sub_filing.description ? sub_filing.filing_number + " - " + sub_filing.description : sub_filing.filing_number,
      //       filing_number:sub_filing.filing_number,
      //       recording_number:sub_filing.recording_number                
      //     })        
      //   })
      // })
  

      subDivisionVals.map((val: any) => {
        this.options.subdivisions.map((subdivison: any) => {
          if (subdivison.number === val.number) {
            subdivison.sub_filings.map((sub_filing: any) => {
              this.filteredFilings.push({
                value:sub_filing.recording_number,
                description:sub_filing.description,
                label:sub_filing.description ? sub_filing.filing_number + " - " + sub_filing.description : sub_filing.filing_number,
                filing_number:sub_filing.filing_number,
                recording_number:sub_filing.recording_number                
              })
            })
            }
        })
      });

      this.filteredFilings = _.uniq(this.filteredFilings, (item) => {
        return item;
      }).sort((a, b) => {
        if (!a.description) a.description = '0';
        if (!b.description) b.description = '0';
        let filing_number_description_a = a.filing_number + " - " + a.description;
        let filing_number_description_b = b.filing_number + " - " + b.description;
        return filing_number_description_a > filing_number_description_b ? 1 : -1;
      });
    }
  
  }

  /* typeahead functionality*/
  filterStreets(street) {
    this.optionSvc.loadStreets(street.query).subscribe(data => {
      this.filteredStreets = jmespath.search(data, "aggregations.streets.buckets[*].key").map(street => {
        return {label:street, value:street};
      });

    }, error1 => {
      console.log(error1);
    });
  }

  /* typeahead filtering */
  filterDistricts(event): Array<any> {
    let query = event.query;
    let self = this;
    this.filteredDistricts = [];
    this.options["tax_districts"].filter(obj => {
      if (obj["number"].indexOf(query) > -1) {
        this.filteredDistricts.push({
          label:obj.name,
          value:obj.number,
          tax_authority_numbers:obj.tax_authority_numbers
        });
      }
    });
    return this.filteredDistricts;
  }

  /* typeahead filtering*/
  filterAuthorities(districtVals?: Array<any>): void {
    /*reset the auth field*/
    this.advSrchFormGrp.controls["taxAuthority"].reset();
    this.filteredAuthorities = [];
    if (!districtVals) {
      this.options.tax_authorities.forEach((auth: any) => {
        this.filteredAuthorities.push({label:auth.name, value:auth.number});
      });
    } else {
      districtVals.forEach((district) => {
        this.options.tax_authorities.filter(auth => {
          if (district.tax_authority_numbers.indexOf(auth.number) > -1) {
            this.filteredAuthorities.push({label:auth.name, value:auth.number});
          }
        });
      });
    }
    this.filteredAuthorities = _.uniq(this.filteredAuthorities, (item) => {
      return item;
    }).sort((a: any, b: any) => {
      return ((Number)(a.value > b.value) - (Number)(b.value > a.value));
    });
  }

  /* typeahead filtering*/
  filterLandUses() {
    this.filteredLandUses = this.options["land_uses"].map((lu: any) => {
      return {value:lu.code, label:lu.description};
    });
  }

  filterNeighborhoods() {
    this.filteredNeighborhoods = _.uniq(this.options["neighborhoods"], (item) => {
      return item.name;
    }).sort((a, b) => (a.name > b.name) ? 1 : -1)
  }

  filterNeighborhoodExtensions(neighborhoodVals: Array<any>): void {
    this.filteredNeighborhoodExtensions = [];
    let temp = []

    if (neighborhoodVals) {
      if (isDevMode) {
        // console.log(neighborhoodVals);
      } 
      neighborhoodVals.map((val: any) => {
        this.options['neighborhoods'].map(item => {
          if (item.name === val.name) {
            temp.push({
              'label': item.extension.trim(),
              'value': item.extension.trim()
            })
          }
        })
      })
      this.filteredNeighborhoodExtensions = _.uniq(temp, (item) => {
        return item.value;
      }).sort((a, b) => (a.value > b.value) ? 1 : -1)     
    }
  }

  /* click of the Search button*/
  triggerSearch(grp?: FormGroup): void {
    const _timmy = timer();

    let minYearBuilt = this.advSrchFormGrp.get('yearBuiltMin').value;
    let maxYearBuilt = this.advSrchFormGrp.get('yearBuiltMax').value;
    if (minYearBuilt || maxYearBuilt) {
      minYearBuilt = !minYearBuilt ? this.minYear : minYearBuilt;
      maxYearBuilt = !maxYearBuilt ? this.maxYear : maxYearBuilt;
      if (Number(minYearBuilt) < this.minYear || Number(maxYearBuilt) > this.maxYear) {
        toastr.error("Year Built must be between " + this.minYear + " and " + this.maxYear + " inclusive");
        return;
      } else if (Number(minYearBuilt) > Number(maxYearBuilt)) {
          toastr.error("From Year Built must be less than To Year Built"); 
          return;       
      }
    }

    this.status = "fetching results...";
    this.searchSvc.SearchInProgress.next(true);
    this.searchSvc.resetResults();
    this.advSrchFormGrp.updateValueAndValidity();
    let self = this;

    if (this.selectedIndex == 0) {
      this.selectedIndex = 1;
    }

    if (isDevMode()) {
      console.log("Form Field Values: ", this.advSrchFormGrp.getRawValue());
    }

    this.searchSvc.getCount(this.advSrchFormGrp.controls, this.currentMapExtent).then((x: ISearchObj) => {
      if (x.preFetch.count == 0) {
        toastr.warning("No results found for your query...");
        self.searchSvc.SearchInProgress.next(false);
        self.status = "";
        return;
      }

      // console.log('--->x.preFetch.count: ' + JSON.stringify(x));
      let nextAcct = null;
      let uberCache: Array<any> = [];

      self.counter = self.resultObject.preFetch.requests;
      // console.log('counter: '+this.counter);
      try {
        let f1 = (theNextAcct) => {
          if (theNextAcct) {
            self.resultObject.accountMilestones.push(theNextAcct);
          }
          self.searchSvc.Search(theNextAcct).subscribe((data: any) => {
            // console.log('data\n' + JSON.stringify(data));
              let _s = data.hits.hits;
              if (_s && _s.length > 0) {
                try {

                  nextAcct = _s.length > 0 ? _s[_s.length - 1]._source["account_number"] : "";

                  uberCache = uberCache.concat(_s);

                } catch (e) {
                  toastr.error(e);
                  self.counter = 0;
                  self.searchSvc.SearchInProgress.next(false);
                  self.status = "Error getting data...";
                  return;
                }

              }
              self.counter--;
              self.status = self.resultObject.hardStop > 0
                ? self.counter * 10000 + " accounts of " + self.resultObject.hardStop + " remaining..."
                : "Fetching:" + uberCache.length + " of " + self.resultObject.preFetch.count + " accounts...";

              _s = null;
              if (self.counter > 0) {
                f1(nextAcct);
              } else {

                self.resultObject.totalHits = uberCache.length || 0;
                try {
                  self.status = "processing results...";
                  self.searchSvc.flattenJSON(uberCache).then((flatt) => {
                    if (flatt.hits) {
                      self.status = "";
                      self.searchSvc.SearchInProgress.next(false);
                      return;
                    }
                    self.resultObject.rows = flatt;
                    self.resultObject.rowCount = self.resultObject.rows.length || 0;
                    self.resultObject.hasResults = self.resultObject.rows.length > 0;
                    self.resultObject.searchTime = _timmy.ms;
                    self.resultObject.displayColumns = jmespath.search(self._Reports.activeRpt, "sort_by(fields, &order)[?display==`true`]");
                  });

                  setTimeout(() => {
                    self.status = "Query time: " + (self.resultObject.searchTime / 500) + "s";
                    try {
                      // $("html, body").animate({
                      //   scrollTop:$("#resultsContainerWrapper").offset().top
                      // }, 1000);
                    } catch (e) {
                      console.error("Scroll Top: ", e);
                    }
                  }, 1000);

                  self.searchSvc.SearchInProgress.next(false);
                  self.resultObject["Report"] = self._Reports.activeRpt.title;
                  self.exportDisabled = false;
                  nextAcct = null;

                } catch (e) {
                  self.status = "Error processing data...";
                  console.error(e);
                  self.counter = 0;
                  self.searchSvc.SearchInProgress.next(false);
                  return;
                }
              }
            },
            (err: HttpErrorResponse) => {
              toastr.error(err.message, err.statusText);
              self.searchSvc.SearchInProgress.next(false);
            });
        };
        f1(null);
      } catch (e) {
        self.searchSvc.SearchInProgress.next(false);
        toastr.error(e);
      }

    });
  }

  /* Move makeCSV(dataTable?: Table) to search-results.component.ts */

  /* sets the active report and it's supporting data */
  setActive(event): void {

    this._Reports.setActiveReport(event);
    if (this.resultObject["Report"] != this._Reports.activeRpt.title) {
      this.exportDisabled = true;
    } else {
      this.exportDisabled = false;
    }
  }

  /* sets the counter to 0 which will stop the iterative query */
  cancelQuery() {
    this.counter = 0;
  }

  /* Custom validity function for year built */
  yearBuiltValidity(event: any, ctrlName: string) {
    // Not needed!!!!!
    // let val = event.target.value;
    // if (val >= 1825 && val <= new Date().getFullYear()) {
    //   //valid!
    // } else {
    //   // this.advSrchFormGrp.controls[ctrlName].setValue(null);
    // }
  }

  saleDateValidity(event: any, ctrlName: string) {
    let val: string = event.target.value.toString();
    let dParts = val.split("/");
    let isDate = new moment(dParts[2] + "-" + dParts[0] + "-" + dParts[1]).toDate();
    let min = this.minSaleDate;
    let max = this.maxSaleDate;

    if (!isDate) {
      this.advSrchFormGrp.controls[ctrlName].setValue(null);
    }

    if (isDate >= min && isDate <= max) {
      //valid!
    } else {
      this.advSrchFormGrp.controls[ctrlName].setValue(null);
    }
  }

  applyFormatted(thePackage: { value: string, control: string }) {
    this.advSrchFormGrp.controls[thePackage.control].setValue(thePackage.value);
  }

  expandAll() {
    this.accordionWrapper.tabs.forEach(tab => {
      tab.selected = true;
    });
  }

  closeAll() {
    this.accordionWrapper.tabs.forEach(tab => {
      tab.selected = false;
    });
  }

  selectAll(event) {
    event.srcElement.select();
  }

  mapExtentChanged(event){
    
    
    this.currentMapExtent = event;

  }

  downloadfile() {
    /*NOTE - until */
    /*this.searchSvc.fileCheck(environment.fileLocation + this._Reports.activeRpt.key + ".zip").subscribe(resp => {
      console.log(resp);*/
    window.open(environment.fileLocation + this._Reports.activeRpt.key + ".zip");
    /*});*/
  }

  handleChange(e) {
    const index = e.index;
    const name = this.tabView.tabs[index].header;

    if(name == "Search Criteria") {
      this.selectedIndex = 0;
    }
    if(name == "Results") {
      this.selectedIndex = 1;
    }
    if(name == "Map") {
      this.selectedIndex = 2;
    }
  }
}
